// Frontend-only value sets for the govern surface. See enums/shell.ts for the rationale.

export const GOVERN_GUIDANCE_KEYS = [
  "source_unavailable",
  "source_not_ready",
  "start_delivery",
  "continue_delivery",
  "resume_delivery",
  "assign_roles",
  "send_back_for_rework",
  "complete_checks",
  "complete_evidence",
  "verify_complete",
  "schedule_review",
  "review_scheduled",
  "no_checks",
] as const;
export type GovernGuidanceKey = (typeof GOVERN_GUIDANCE_KEYS)[number];
export const GOVERN_GUIDANCE_KEY = {
  SOURCE_UNAVAILABLE: "source_unavailable",
  SOURCE_NOT_READY: "source_not_ready",
  START_DELIVERY: "start_delivery",
  CONTINUE_DELIVERY: "continue_delivery",
  RESUME_DELIVERY: "resume_delivery",
  ASSIGN_ROLES: "assign_roles",
  SEND_BACK_FOR_REWORK: "send_back_for_rework",
  COMPLETE_CHECKS: "complete_checks",
  COMPLETE_EVIDENCE: "complete_evidence",
  VERIFY_COMPLETE: "verify_complete",
  SCHEDULE_REVIEW: "schedule_review",
  REVIEW_SCHEDULED: "review_scheduled",
  NO_CHECKS: "no_checks",
} as const satisfies Record<string, GovernGuidanceKey>;

export const GOVERNANCE_STATES = [
  "ready_for_delivery",
  "in_delivery",
  "ready_for_review",
  "needs_rework",
  "verified",
  "review_scheduled",
] as const;
export type GovernanceState = (typeof GOVERNANCE_STATES)[number];
export const GOVERNANCE_STATE = {
  READY_FOR_DELIVERY: "ready_for_delivery",
  IN_DELIVERY: "in_delivery",
  READY_FOR_REVIEW: "ready_for_review",
  NEEDS_REWORK: "needs_rework",
  VERIFIED: "verified",
  REVIEW_SCHEDULED: "review_scheduled",
} as const satisfies Record<string, GovernanceState>;

export const GOVERN_ROLE_KEYS = [
  "deliveryOwner",
  "reviewer",
  "approver",
  "verifier",
  "reviewOwner",
] as const;
export type GovernRoleKey = (typeof GOVERN_ROLE_KEYS)[number];
export const GOVERN_ROLE_KEY = {
  DELIVERY_OWNER: "deliveryOwner",
  REVIEWER: "reviewer",
  APPROVER: "approver",
  VERIFIER: "verifier",
  REVIEW_OWNER: "reviewOwner",
} as const satisfies Record<string, GovernRoleKey>;

export const VERIFICATION_RESULTS = [
  "not_checked",
  "pass",
  "fail",
  "not_applicable",
] as const;
export type VerificationResult = (typeof VERIFICATION_RESULTS)[number];
export const VERIFICATION_RESULT = {
  NOT_CHECKED: "not_checked",
  PASS: "pass",
  FAIL: "fail",
  NOT_APPLICABLE: "not_applicable",
} as const satisfies Record<string, VerificationResult>;

// The two guidance keys that mean "the brief's source is not usable yet". Both
// render the same action, so they are named together rather than restated.
export const GOVERN_SOURCE_BLOCKERS = [
  "source_unavailable",
  "source_not_ready",
] as const satisfies readonly GovernGuidanceKey[];
export type GovernSourceBlocker = (typeof GOVERN_SOURCE_BLOCKERS)[number];

// Guidance keys that render their own control — a blocker message, or one of
// the dedicated buttons above — so the standard action row is suppressed.
export const GOVERN_SELF_HANDLED_GUIDANCE_KEYS: readonly GovernGuidanceKey[] = [
  "assign_roles",
  "send_back_for_rework",
  "source_unavailable",
  "source_not_ready",
];
